import { module } from 'modujs';
import { createApp } from "vue/dist/vue.esm-bundler.js"
import PartnershipsInquiryComponents from '../components/PartnershipsInquiryComponents.vue';
import TranslationStrings from '../components/translationStrings.js';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.initVue();
    }
    initVue(){
        if (window.PartnershipsGlob) return ;
        window.PartnershipsGlob = true;
        const self = this;
        //get data-lang
        let lang = self.el.getAttribute('data-lang');
        let completion_text = self.el.getAttribute('data-completion_text');

        if(window.Partnerships) {
            //console.log('SalesWebsiteComponents already initialized');
            return;
        }
        window.Partnerships = createApp({
            template: '<PartnershipsInquiryComponents :completion_text="completion_text" />',
            components: {
                PartnershipsInquiryComponents,
            },
            data() {
                return {
                    lang: lang,
                    completion_text: completion_text,
                    translationStrings: TranslationStrings(),
                }
            },
            mounted() {
                if (typeof window.showTranslations === 'undefined') {
                    window.showTranslations = this.showTranslations
                }
            },
            methods: {
                translateString(text) {
                    let translationStrings = this.$root.translationStrings
                    let lang = this.$root.lang

                    if (!translationStrings[text]) translationStrings[text] = {}
                    if (!translationStrings[text]['fr']) translationStrings[text]['fr'] = text
                    if (!translationStrings[text]['en']) translationStrings[text]['en'] = text
                    if (!translationStrings[text][lang]) translationStrings[text][lang] = text //if other languages

                    return translationStrings[text][lang]
                },
                showTranslations() {
                    return this.$root.translationStrings
                }
            }
        })
        window.Partnerships.config.globalProperties._t = function (text) {
            // "this" inside here refers to the component instance calling _t.
            // If you rely on root data, you might do:
            return this.$root.translateString(text);
          };
        window.Partnerships.config.globalProperties.modu = this;
        window.Partnerships.mount(self.el)
    }

    destroy() {
        if(window.Partnerships) {
            window.Partnerships.unmount();
            window.Partnerships = null;
        }
        if(window.PartnershipsGlob) {
            window.PartnershipsGlob = null;
        }
    }
}